/*
 * Routes-addresses.ts
 * Description: Includes the declaration of the
 * addresses routes for Vue Router
 */

// Importing components
import PageAddresses from '@/pages/addresses/PageAddresses.vue';
import PageAddressesCreate from '@/pages/addresses/PageAddressesCreate.vue';
import PageAddressesUpdate from '@/pages/addresses/PageAddressesUpdate.vue';

const routesAdresses = [
    // Defining the addresses page route
    {
        path: '/addresses',
        name: 'addresses',
        component: PageAddresses,
        meta: { requiresAuth: true },
    },
    // Defining the addresses create page route
    {
        path: '/addresses/create',
        name: 'addresses-create',
        component: PageAddressesCreate,
        meta: { requiresAuth: true },
    },
    // Defining the addresses update page route
    {
        path: '/restaurants/:id/addresses/update',
        name: 'addresses-update',
        component: PageAddressesUpdate,
        props: { id: Number },
        meta: { requiresAuth: true },
    },
];
export default routesAdresses;
